class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const removeFilterNode = this.querySelector('a')
    if (!removeFilterNode) return;
    removeFilterNode.addEventListener('click', (e) => {
      e.preventDefault();
      const filtersForm = this.closest('collection-filters-form') || document.querySelector('collection-filters-form');
      if (!filtersForm) return;
      filtersForm.renderPage(new URL(removeFilterNode.href).searchParams.toString());
    });
  }
}

if (!customElements.get('facet-remove')) {
  customElements.define('facet-remove', FacetRemove);
}
